import React, { useContext, useEffect, useState, useCallback } from 'react';
import { ReactComponent as Back } from '../../../assets/svg/chevron-left.svg';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import Context from '../../../context/context';
import { ReactComponent as DoubleArrowIcon } from '../../../assets/svg/up-arrow.svg';
import moment from 'moment';
import Pagination from './CustomPagination';
import DeliverablesTable from './DeliverablesTable';
import LoadingBar from '../../components/global/loadingBar';
import CreateDeliverSlider from '../../components/modals/Deliverables/CreateDeliverSlider';
import { ReactComponent as PlusIcon } from '../../../assets/svg/plus-gray.svg';
import { ReactComponent as ArrowIcon } from '../../../assets/svg/deliverables/single_up_arrow.svg';
import { ReactComponent as EqualIcon } from '../../../assets/svg/deliverables/equalto.svg';
import { ReactComponent as DownIcon } from '../../../assets/svg/deliverables/single_down_arrow.svg';
const CreateDeliverable = () => {
	const urlParams = useParams();
	const navigate = useNavigate();
	const [load, setLoad] = useState(true);
	const [searchParams, setSearchParams] = useSearchParams();
	let {
		deliverableInfo: {
			getAlldeliverablesData,
			deliverablesData,
			getAllEventList,
			associatedTenants,
			getAllProjectsList,
			projectsList,
			updateModalState,
			createNewDeliverableState,
			updateCreateDeliverableState,
			UpdateDeliverableState,
			updateRecord,
		},
	} = useContext(Context);

	const params = Object.fromEntries(searchParams);

	const [data, setData] = useState({
		selectedworkspace: { label: urlParams.workspaceID, value: params.workspaceId },
		selectedProject: { label: params.projectLabel, value: urlParams.projectID },
		filters: {
			workspaceFilter: [params.workspaceId],
			page: 1,
			limit: 10,
			projectsFilter: urlParams.projectID,
		},
		dataSource: [],
		totalDocs: 0,
		vendorUsers: [],
		associatedTenant: [],
		associatedTenantsId: [],
		associatedTenantsName: [],
		vendorsId: [],
		projectsLists: [],
		projects: [],
		projectId: [],
		statusFiltercount: {},
		all: 0,
		overdue: 0,
		unassigned: 0,
		unscheduled: 0,
		slider: false,
	});
	const createParams = useCallback(() => {
		const params = Object.fromEntries(searchParams);
		params.page = data?.filters?.page;
		setSearchParams((prev) => {
			return {
				...params,
			};
		});
	}, [data?.filters]);

	useEffect(() => {
		getAllEventList(urlParams.vendorID);
		getAllProjectsList(urlParams.vendorID);
		getAlldeliverablesData(data.filters, urlParams.vendorID);
		createDelay();
	}, []);
	useEffect(() => {
		createParams();
		getAlldeliverablesData(data.filters, urlParams.vendorID);
	}, [data?.filters]);
	useEffect(() => {
		setData((prev) => {
			return {
				...prev,
				totalDocs: deliverablesData?.vendorDeliverablesList?.totalDocs || 0,
				dataSource: deliverablesData?.vendorDeliverablesList?.data || [],
			};
		});
	}, [deliverablesData]);

	//assosciated tennants
	useEffect(() => {
		let vendorUsers = associatedTenants?.vendorUsers || [];
		let associatedTenant = associatedTenants?.vendorInfo?.associatedTenants || [];
		let associatedTenantsId, associatedTenantsName, vendorsId;
		if (associatedTenant?.length) {
			associatedTenantsId = associatedTenant.map((ele) => ele._id);
			associatedTenantsName = associatedTenant.map((ele) => {
				return {
					key: ele._id,
					name: ele.workspaceId,
				};
			});
		}

		if (vendorUsers?.length) {
			vendorsId = vendorUsers.map((ele) => ele.id);
			vendorUsers = vendorUsers.map((ele) => {
				return {
					key: ele.id,
					name: ele.firstName + ' ' + ele.lastName,
				};
			});
		}
		setData((prev) => {
			return {
				...prev,
				vendorUsers,
				associatedTenant,
				associatedTenantsId,
				associatedTenantsName,
				vendorsId,
			};
		});
	}, [associatedTenants]);

	useEffect(() => {
		let projectsLists = projectsList?.vendorsProjects?.data; //projectlist
		let projects, projectId;
		if (projectsLists?.length) {
			projectId = projectsLists.map((ele) => ele.id);
			projects = projectsLists.map((ele) => {
				return {
					key: ele.id,
					name: ele.title,
				};
			});
		}
		setData((prev) => {
			return {
				...prev,
				projectsLists,
				projectId,
				projects,
			};
		});
	}, [projectsList]);

	useEffect(() => {
		if (createNewDeliverableState?.status === 'success') {
			getAlldeliverablesData(data.filters, urlParams.vendorID);
			updateCreateDeliverableState({ type: createNewDeliverableState, data: null });
			updateModalState('createModal', false);
		}
	}, [createNewDeliverableState]);

	useEffect(() => {
		if (UpdateDeliverableState?.status === 'success') {
			getAlldeliverablesData(data.filters, urlParams.vendorID);
			updateCreateDeliverableState({ type: UpdateDeliverableState, data: null });
			setData((prev) => {
				return { ...prev, slider: false };
			});
			updateRecord(null);
			updateModalState('createModal', false);
		} else if (UpdateDeliverableState?.status === 'caneled') {
			setData((prev) => {
				return { ...prev, slider: false };
			});
			updateRecord(null);
			updateModalState('createModal', false);
		}
	}, [UpdateDeliverableState]);

	const columns = [
		{
			title: 'ID',
			dataIndex: 'id',
			key: 'ID',
			renderis: (record) => {
				const index = data.associatedTenantsId?.indexOf(record.tenantId);

				let str = '';
				if (index !== -1) {
					str = data.associatedTenant[index]?.workspaceKey + '-' + record.slNo;
				}

				return <span>{str}</span>;
			},
		},
		{
			title: 'DELIVERABLE',
			dataIndex: 'name',
			key: 'DELIVERABLE',
			renderis: (record) => {
				const index = data.projectId?.indexOf(record.projectId);
				return (
					<span style={{ display: 'flex', flexDirection: 'column' }}>
						<span style={{ marginBottom: '6px' }}>
							{data.projects?.[index]?.name || ''}
						</span>
						<span style={{ color: '#B0B0B0' }}>{record.title}</span>
					</span>
				);
			},
		},
		{
			title: 'STATUS',
			dataIndex: 'status',
			key: 'STATUS',
			renderis: (record) => {
				let col;

				let status = record.status.toUpperCase();
				let state = status;
				if (status !== 'DONE') {
					status = status.split('');
					status.splice(2, 0, ' ');
					status.join('');
					status = status.join('');
				}
				if (state === 'TODO') {
					col = '#9F4DB7';
				} else if (state === 'INPROGRESS') {
					col = '#5383EC';
				} else if (state === 'INREVIEW') {
					col = '#8EE2C7';
				} else if (state === 'DONE') {
					col = '#479A5F';
				} else if (state === 'ONHOLD') {
					col = 'rgb(255, 87, 51)';
				}

				return (
					<span
						style={{ display: 'flex', alignItems: 'center' }}
						className="delivarableStatusCheck"
					>
						<b style={{ backgroundColor: col }}></b>
						<span>{status}</span>
					</span>
				);
			},
		},
		{
			title: 'ASSIGNED TO',
			dataIndex: 'assignedTo',
			key: 'ASSIGNED',
			renderis: (record) => {
				const index = data.vendorsId?.indexOf(record.assignedTo);
				return <span>{record.assignedTo?.name || ''}</span>;
			},
		},
		{
			title: 'QUANTITY',
			dataIndex: 'quantity',
			key: 'QUANTITY',
			renderis: (record) => {
				return (
					<span style={{ display: 'flex', justifyContent: 'center' }}>
						{record.quantity}
					</span>
				);
			},
		},
		{
			title: 'PRIORITY',
			dataIndex: 'priority',
			key: 'PRIORITY',
			renderis: (record) => {
				if (record.priority === 'critical') {
					return (
						<span className="priorityIcons">
							<DoubleArrowIcon />
						</span>
					);
				} else if (record.priority === 'high') {
					return (
						<span className="priorityIcons">
							<ArrowIcon />
						</span>
					);
				} else if (record.priority === 'low') {
					return (
						<span className="priorityIcons">
							<DownIcon />
						</span>
					);
				} else {
					return (
						<span className="priorityIcons">
							<EqualIcon />
						</span>
					);
				}
			},
		},
		{
			title: 'LAST UPDATED',
			dataIndex: 'updatedAt',
			key: 'UPDATED',
			renderis: (record) => {
				const index = data.vendorsId?.indexOf(record.updatedBy);
				return (
					<span style={{ display: 'flex', flexDirection: 'column' }}>
						<span style={{ color: '#B0B0B0', marginBottom: '6px' }}>
							{data.vendorUsers[index]?.name || ''}
						</span>
						<span style={{ color: 'E4E5E6', fontSize: '12px' }}>
							{moment.unix(record.updatedAt).local().startOf('seconds').fromNow()}
						</span>
					</span>
				);
			},
		},
	];

	const onChange = useCallback((page) => {
		setData((prev) => {
			return {
				...prev,
				filters: {
					...prev.filters,
					page,
				},
			};
		});
	}, []);

	const createDelay = useCallback(() => {
		setTimeout(() => {
			setLoad(false);
		}, 200);
	}, []);

	const sayChange = (record) => {
		const tenantId = record.tenantId;
		const workspaceValueIndex = data.associatedTenantsId.indexOf(tenantId);
		let workspaceLabelValue = data.associatedTenantsName[workspaceValueIndex];

		workspaceLabelValue = { label: workspaceLabelValue.name, value: tenantId };

		const projectLabelValue = { label: record.projectTitle, value: record.projectId };
		setData((prev) => {
			return { ...prev, record, workspaceLabelValue, projectLabelValue, slider: true };
		});

		updateModalState('createModal', true);
		updateRecord(record);
	};

	return (
		<>
			{!deliverablesData || !associatedTenants || !projectsList || load ? (
				<LoadingBar />
			) : (
				<div className="assign-receive-container">
					<div
						className="arc-header"
						style={{ position: 'fixed', width: 'calc(100vw - 80px)', zIndex: 10 }}
					>
						<div
							className="back-btn"
							onClick={() => {
								navigate(-1);
							}}
						>
							<Back />
						</div>
						<div className="arch-item">
							<span>Workspace</span>

							<b>{data.selectedworkspace.label}</b>
						</div>
						<div className="next-btn">
							{' '}
							<Back />
						</div>
						<div className="arch-item">
							<span>Project</span>
							<b>{data.selectedProject.label}</b>
						</div>
						<div className="next-btn">
							{' '}
							<Back />
						</div>

						<div className="arch-item">
							<span>Deliverable</span>
						</div>
						<div className="actn-btn">
							<a
								href
								// onClick={(e) =>
								// this.toggleCreateShoot(e)}
								onClick={() => updateModalState('createModal', true)}
								style={{ display: 'flex', alignItems: 'center' }}
							>
								<PlusIcon style={{ marginRight: '4px' }} /> Create deliverable
							</a>
						</div>
					</div>
					<div
						className={'table shoots-table'}
						id={'scrollableDiv-shoots-vendors'}
						style={{
							marginTop: '1.5em',
							maxHeight: '63vh',
						}}
					>
						<DeliverablesTable
							columns={columns}
							dataSource={data.dataSource}
							onClickView={sayChange}
						/>
						<div
							style={{
								display: 'flex',
								justifyContent: 'flex-end',
								paddingRight: '15px',
							}}
						>
							<div>
								<Pagination
									totalItems={data.totalDocs}
									pageSize={10}
									currentPage={+data.filters.page || 1}
									onChangePage={onChange}
								/>
							</div>
						</div>
					</div>
					<CreateDeliverSlider
						project={data.selectedProject}
						workspace={data.selectedworkspace}
					/>

					{data.slider ? (
						<CreateDeliverSlider
							project={data.projectLabelValue}
							workspace={data.workspaceLabelValue}
							type="edit"
						/>
					) : (
						''
					)}
				</div>
			)}
		</>
	);
};

export default CreateDeliverable;
